module.exports = __webpack_public_path__ + "static/media/btn-arrow-white-o.f3855001.svg";